import {IntermediatePart} from "../../intermediatePart";
import {Shower} from "../../parts/shower";

export default class WindowBody extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'window_body';
    this.partName = 'Window';
    this.translateId = "visualizer.bathroom.window";
    this.canBeDisabled = true;
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const layout = this.getParent().layout;
    const showerParent = layout.parts[Shower.id];
    const showerSize = showerParent.showerSize();
    if (showerParent && showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      });
    }
    return conditions
  }

}
